import BX from 'BX';
import {anyExceptDigits, format} from '../PhoneFormatter';
import Vue from 'vue';

function formattedValue(value) {
    const formattedValue = format(value.replace(anyExceptDigits, ''));

    if (formattedValue)
        return `+${formattedValue}`;
    else
        return '';
}

function onInput({target}) {
    let value = target.value.replace(anyExceptDigits, '');

    target.value = formattedValue(value);
}

export const InputPhoneMask = {
    functional: true,
    props: {
        value: String
    },
    render(h, {props, data, listeners}) {
        return (
            <input
                type="tel"
                {...data}
                domPropsValue={formattedValue(props.value)}
                onInput={onInput}
                onChange={onInput}
                {...listeners}
            />
        );
    }
}

export const InputPhoneMaskRU = {
    mixins: [InputPhoneMask],
    props: {
        value: {
            type: String,
            default: '7'
        }
    }
}

// Imitating

export function registerComponent() {
    const isRegistered = Vue.component('input-phone-mask');

    if (!isRegistered)
        Vue.component('input-phone-mask', InputPhoneMaskRU);
}

BX.namespace('InputPhoneMask');

BX.InputPhoneMask.init = function () {
    registerComponent();

    document
        .querySelectorAll('[is="input-phone-mask"]')
        .forEach((elem) => new Vue({el: elem}));
}
